import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { MortgagePromoSearchTypeContainer } from '../../containers/advancedFilters/MortgagePromoSearchTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const mortgagePromoSearchType: IFilter = {
  component: MortgagePromoSearchTypeContainer,
  availability: ({ jsonQuery }) => isAvailable(FDealType.Sale, FOfferType.FlatNew)(jsonQuery),
};
